<template>
  <div class="pager-body">
    <div class="row">
      <button
        :disabled="!vacancyInquiry.is_prev"
        type="button"
        class="button button-prev"
        @click="getOthersVacancy(2)"
      >
        <i class="fa fa-fw fa-angle-left"></i>
        前の列車
      </button>
    </div>
    <div class="row">
      <button
        :disabled="!vacancyInquiry.is_next"
        type="button"
        class="button button-next"
        @click="getOthersVacancy(1)"
      >
        次の列車
        <i class="fa fa-fw fa-angle-right"></i>
      </button>
    </div>
  </div>

  <!-- ローディングダイアログ -->
  <DialogLoading ref="DialogLoading" :timeout-seconds="21000" />

  <!-- 電波状況が悪い場合のダイアログ　-->
  <DialogBadReception ref="DialogBadReception" />

  <DialogDuringMaintenance ref="DialogDuringMaintenance" />

  <DialogUnexpectedError ref="DialogUnexpectedError" />
</template>

<script>
import { computed, ref } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

import API from "@/API";

import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "MFITTSelectTrain",
  setup() {
    const store = useStore();
    const route = useRoute();

    const DialogLoading = ref(null);
    const DialogBadReception = ref(null);
    const DialogUnexpectedError = ref(null);
    const DialogDuringMaintenance = ref(null);

    // 列車の空席情報
    const vacancyInquiry = computed(
      () => store.getters["MFITT/vacancyInquiry"]
    );

    // vacantSeatDisplayNum=1:次の列車、vacantSeatDisplayNum=2:前の列車
    const getOthersVacancy = async (vacantSeatDisplayNum) => {
      DialogLoading.value.openDialog();

      try {
        const trainInfo = vacancyInquiry.value.train_info;
        let trainIndexNum = "";
        if (vacantSeatDisplayNum === 1) {
          trainIndexNum = trainInfo.slice(-1)[0].train_index_number;
        } else {
          trainIndexNum = trainInfo[0].train_index_number;
        }

        // 指定された列車の空席情報を取得
        await API.getVacancyInquiry(
          vacantSeatDisplayNum,
          trainIndexNum,
          //列車変更の場合はチケットIDをパラメータに付与する。
          route.query.changing_limited_express_ticket_id
            ? route.query.changing_limited_express_ticket_id
            : ""
        );
        DialogLoading.value.closeDialog();
      } catch (e) {
        if (e.response.data.message) {
          // 電波がない場合、e.response.data.messageが存在しない
          // loadingを表示し続け、そちらでタイムアウトさせる
          DialogLoading.value.closeDialog();
          if (e.response.data.message === "回線が込み合っています") {
            DialogBadReception.value.openDialog();
            // MWのメンテナンス中
          } else if (e.response.status == 503) {
            DialogDuringMaintenance.value.openDialog(e.response.data);
          } else {
            // nativeにエラー内容送信
            nativeHandlerService.ncSendMfittError(e.response.data.message);
            DialogUnexpectedError.value.openDialog();
          }
        } else {
          nativeHandlerService.ncSendMfittError(
            "MFITTSelectTrain getOthersVacancy()"
          );
        }
      }
    };

    return {
      vacancyInquiry,
      getOthersVacancy,
      DialogLoading,
      DialogBadReception,
      DialogUnexpectedError,
      DialogDuringMaintenance,
    };
  },
};
</script>
<style lang="scss" scoped>
.pager-body {
  display: flex;
  margin: 30px 0;
}

.pager-body .row {
  width: calc(50% - 10px);
  margin: 0 5px;
}

.pager-body button {
  display: block;
  width: 100%;
  height: 45px;
  margin-bottom: 15px;
  border: none;
  font-size: 14px;
  font-weight: bold;
  box-shadow: var(--defaultBoxShadow);
}

.pager-body button.button-prev {
  background-color: #f2f2f2;
  color: #000000;
  border-top-left-radius: 30px;
  border-bottom-left-radius: 30px;
}

.pager-body button.button-next {
  background-color: #f2f2f2;
  color: #000000;
  border-top-right-radius: 30px;
  border-bottom-right-radius: 30px;
}

.pager-body button:disabled {
  background-color: #e9e9e9;
  color: #999999;
}
</style>
